import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

import { ProfileStore } from '@asset-solutions/customer-portal/auth/data-access';
import type { OrderColumn } from '@asset-solutions/customer-portal/orders/models';
import { selectSummaryCounts } from '@asset-solutions/customer-portal/orders/store';
import { SideDrawerComponent } from '@asset-solutions/customer-portal/shared/ui';
import { LetDirective } from '@ngrx/component';
import { Store } from '@ngrx/store';

import { ColumnPickerComponent } from '../column-picker/column-picker.component';
import { OrderFiltersComponent } from '../order-filters/order-filters.component';
import { OrderSearchStore } from '../order-search.store';
import { ReportSummaryComponent } from '../report-summary/report-summary.component';
import { TableContainerComponent } from '../table-container/table-container.component';

@Component({
  selector: 'orders-main',
  imports: [
    ColumnPickerComponent,
    MatIcon,
    MatButton,
    OrderFiltersComponent,
    SideDrawerComponent,
    TableContainerComponent,
    LetDirective,
    ReportSummaryComponent
  ],
  templateUrl: 'main.component.html',
  styleUrl: 'main.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [OrderSearchStore]
})
export class MainComponent {
  private readonly profileStore = inject(ProfileStore);
  private readonly store = inject(Store);

  public columnPickerOpen = signal(false);
  public orderColumns = this.profileStore.orderColumns;
  public summaryCounts$ = this.store.select(selectSummaryCounts);

  public updateOrderColumns(orderColumns: OrderColumn[]): void {
    this.profileStore.updateOrderColumns(orderColumns);
  }
}
